import { useQuery } from '@tanstack/react-query';
import { fetchFloorManagerOnDuty } from './api';

export const FLOOR_MANAGER_ON_DUTY_QUERY_KEY = ['discord-activity-floor-manager-on-duty'] as const;

/**
 * Polls the Activity floor-manager-on-duty endpoint via React Query.
 *
 * Single source of truth for "who's wearing the crown" across every Activity
 * surface — the always-visible FM tile on the consolidated view AND the star
 * badge applied to the matching chip in `<InstanceParticipantsHeader>` both
 * read this cache, so the two affordances cannot disagree.
 *
 * 30s refetch — the FM rotates on schedule-block boundaries (typically hours
 * apart), so a slower cadence than the queue/ops-snapshot polling is fine and
 * keeps the polling budget tight.
 */
export function useFloorManagerOnDuty(accessToken: string | undefined) {
  return useQuery({
    queryKey: FLOOR_MANAGER_ON_DUTY_QUERY_KEY,
    queryFn: () => fetchFloorManagerOnDuty(accessToken!),
    enabled: Boolean(accessToken),
    refetchInterval: 30_000,
    refetchIntervalInBackground: true,
    retry: 1,
    staleTime: 0,
  });
}
